export const customFieldsData = [
  {
    id: "1",
    module: "Expense",
    label: "Name",
    type: "Text",
    defaultValue: "Name",
    required: "Required",
    status: "Active",
  },
  {
    id: "2",
    module: "Transaction",
    label: "Comment",
    type: "Textarea",
    defaultValue: "Enter Comments",
    required: "Required",
    status: "Active",
  },
];
